export const messageData = {
  LANG: 'en',
  DATA: {
    SAVE_CONFIRM: {
      TITLE: 'Submit Confirmation',
      DESCRIPTION: 'Are you sure want to submit?',
      WAIT_DESCRIPTION: 'Submitting...',
      MESSAGE: 'Information has been submit.',
    },
    UPDATE_CONFIRM: {
      TITLE: 'Update Confirmation',
      DESCRIPTION: 'Are you sure want to update this data?',
      WAIT_DESCRIPTION: 'Updating data...',
      MESSAGE: 'Data has been updated.',
    },
    DELETE_CONFIRM: {
      TITLE: 'Delete Confirmation',
      DESCRIPTION: 'Are you sure want to delete this data? All changes will be discarded.',
      WAIT_DESCRIPTION: 'Deleting data...',
      MESSAGE: 'Data has been deleted.',
    },
    ACTIVATE_CONFIRM: {
      TITLE: 'Activate Confirmation',
      DESCRIPTION: 'Are you sure want to activate this cashback? All changes will be discarded.',
      WAIT_DESCRIPTION: 'Activating data...',
      MESSAGE: 'Cashback has been activated.',
    },
    SAVE: {
      SUCCESS: 'Data successfully submitted',
      ERROR: 'Data cannot be submit! Please contact our support.',
    },
    UPDATE: {
      SUCCESS: 'Data successfully updated',
      ERROR: 'Data cannot be update! Please contact our support.',
    },
    DELETE: {
      SUCCESS: 'Data successfully deleted',
      ERROR: 'Data cannot be delete! Please contact our support.',
    },
    ACTIVATE: {
      SUCCESS: 'Successfully activate',
      ERROR: 'Error to activate cashback! Please contact our support.',
    },
  },
  ERROR: 'Service currently not available. Please Contact our support.',
  REQUIRED: 'Please fill in all required field.',
};
